(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Installer-forms"] && !Shopify.designMode) return;
  try {
    


$( document ).ready(function() {
     $( "#tab1-click" ).trigger( "click" );



});
 

  
  $("#tab1-click").click(function() {
      $(".tab").removeClass("selected-tab1");
    $(".tab").removeClass("selected-tab2");
      $(".tab").removeClass("selected-tab3");
    $(".tabcontent").hide();
    $("#tab1").show();
    $(".tab").addClass("selected-tab1");
    
});


  $("#tab2-click").click(function() {
      $(".tab").removeClass("selected-tab1");
    $(".tab").removeClass("selected-tab2");
      $(".tab").removeClass("selected-tab3");
    $(".tabcontent").hide();
    $("#tab2").show();
    $(".tab").addClass("selected-tab2");
    
});

    $("#tab3-click").click(function() {
      $(".tab").removeClass("selected-tab1");
    $(".tab").removeClass("selected-tab2");
      $(".tab").removeClass("selected-tab3");
    $(".tabcontent").hide();
    $("#tab3").show();
      $(".tab").addClass("selected-tab3");
    
    
});


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    


$( document ).ready(function() {
     $( "#tab1-click" ).trigger( "click" );

$('#tab2').append($('.all-content'));

});



  $("#tab1-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab1").show();
    $("#tab1-click").addClass("selected");

});


  $("#tab2-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab2").show();
    $("#tab2-click").addClass("selected");

});

    $("#tab3-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab3").show();
      $("#tab3-click").addClass("selected");


});

      $("#tab4-click").click(function() {
    $(".tablinks").removeClass("selected");
    $(".tabcontent").hide();
    $("#tab4").show();
        $("#tab4-click").addClass("selected");


});

    $(document).on('click', '.faq-accordian' , function(){
    console.log("hello");
      $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-calculator"] && !Shopify.designMode) return;
  try {
    

  var gravelamount = 10;
    var resinamount = 10;

  $(document).on('click', '.submit-calculations' , function(){
    var contingancy = $('#contingency').val();
    console.log(contingancy );
    console.log("^ contingancy");


    var meters = $('#meters').val();
    console.log(meters );
    console.log("^ meters");
    
        var depth = $('#depth').val();
    console.log(depth );
    console.log("^ depth");




        var resin = $('#resin').val();
    console.log(resin );
    console.log("^ resin");
    if(meters => 9 && meters < 11){
      gravelamount = 100
      resinamount = 21
    }
$('.gravel-needed').html('');
    $('.resin-needed').html('');
$('.submit-calculations').append("<p class='gravel-needed'> gravel needed   " + gravelamount + "Kg")
    $('.submit-calculations').append("<p class='resin-needed' > resin needed  " + resinamount + "Kg")
    
  });

  



  } catch(e) { console.error(e); }
})();
})();
